import { useState } from "react";

export const OfferPonctual = () => {
  const [isHalfHour, setIsHalfHour] = useState(false);
  return (
    <div className="flex flex-col p-6 mx-auto max-w-lg text-center text-gray-900 bg-white rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-8 dark:bg-gray-800 dark:text-white">
      <h3 className="mb-4 text-2xl font-semibold">Session Brainstorming</h3>
      <p className="font-light text-gray-500 sm:text-lg dark:text-gray-400">
        Discutez de votre projet et obtenez des conseils sur les technologies,
        le planning et les coûts réelles à mettre en place.
      </p>
      <div className="flex flex-row justify-center items-center my-[20px]">
        <input
          value={isHalfHour}
          type="checkbox"
          className="toggle bg-neutral"
          onChange={() => {
            setIsHalfHour(!isHalfHour);
          }}
        />
      </div>
      <div className="flex flex-row justify-center items-center">
        <div
          className={
            "flex justify-center items-baseline my-8 " +
            (isHalfHour && " hidden ")
          }
        >
          <span className="mr-2 text-5xl font-extrabold">110€</span>
          <span className="text-gray-500 dark:text-gray-400">
            /session 1 heure
          </span>
        </div>
        <div
          className={
            "flex justify-center items-baseline my-8 " +
            (!isHalfHour && " hidden ")
          }
        >
          <span className="mr-2 text-5xl font-extrabold">60€</span>
          <span className="text-gray-500 dark:text-gray-400">
            /session 30 minute
          </span>
        </div>
      </div>

      <ul className="mb-8 space-y-4 text-left">
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span>
            Analyse des besoins et définition des coûts réels pour les
            fonctionnalités essentielles
          </span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span>Conseils sur les technologies</span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span>Évaluation du planning</span>
        </li>
        <li className="flex items-center space-x-3">
          <svg
            className="flex-shrink-0 w-5 h-5 text-green-500 dark:text-green-400"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
              clip-rule="evenodd"
            ></path>
          </svg>
          <span>Définition des coûts</span>
        </li>
      </ul>
      <a href={isHalfHour?"https://forms.gle/BScQnb5KEeAbMKvU6":"https://forms.gle/sVsmeNpyrkbWdBxaA"} rel="noreferrer" target="_blank" className="btn btn-neutral">Prendre rendez-vous</a>
    </div>
  );
};
